import React, { useState, useEffect } from "react";
import "./../Styles/AddDesign.css";
import { API, UPLOADS } from "./../../config/api";

export default function AddDesign() {
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
  // ✅ FIX 1: Move fileResetKey inside component with useRef
  const [fileResetKey, setFileResetKey] = useState(Date.now());

  // ✅ FIX 2: Move ALL other scattered state declarations to TOP
  const [form, setForm] = useState({
    category: "",
    designCode: "",
    stitch: "",
    area: "",
    color: "",
    details: "",
    concepts: [],
    jpegFile: null,
    embFile: null,
  });
  const [concepts, setConcepts] = useState([]);
  const [selectedConcepts, setSelectedConcepts] = useState([]);
  const [showConceptModal, setShowConceptModal] = useState(false);
  const [newConcept, setNewConcept] = useState("");
  const [designs, setDesigns] = useState([]);
  const [editData, setEditData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilterCategory, setSelectedFilterCategory] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const categories = ["Malti", "Sequience", "Cording", "Chain", "Beads"];
  const [previewImage, setPreviewImage] = useState("");

  // Close popup/modal with Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key !== "Escape") return;

      if (previewImage) {
        setPreviewImage("");
        return;
      }

      if (editData) {
        setEditData(null);
        return;
      }

      if (showConceptModal) {
        setShowConceptModal(false);
        return;
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [previewImage, editData, showConceptModal]);
  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();

      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteConcept = async (conceptId) => {
    if (!window.confirm("Are you sure you want to delete this concept?"))
      return;

    try {
      const formData = new FormData();
      formData.append("id", conceptId);

      const res = await fetch(API.DELETE_CONCEPT, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      if (data.status) {
        fetchConcepts(); // Refresh the list
      }
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  // Pagination State

  const recordsPerPage = 10;
  useEffect(() => {
    fetchDesigns();
    fetchConcepts();
  }, []);

  // Reset to page 1 whenever search or category changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedFilterCategory]);

  const fetchDesigns = async () => {
    try {
      const res = await fetch(API.LIST_ALL_DESIGNS);
      const data = await res.json();
      if (data.status) setDesigns(data.data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  /* ================= FILTER & PAGINATION LOGIC ================= */
  // 1. Filter the entire dataset first
  const filteredDesigns = designs.filter((d) => {
    const matchesCategory =
      selectedFilterCategory === "all" || d.category === selectedFilterCategory;
    const matchesSearch = d.design_code
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // 2. Calculate pagination based on the filtered results
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredDesigns.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );
  const totalPages = Math.ceil(filteredDesigns.length / recordsPerPage);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.jpegFile || !form.embFile) {
      alert("Please select both JPEG and EMB files");
      return;
    }

    // ==========================================
    // MAX FILE SIZE = 5 MB
    // ==========================================

    const maxFileSize = 5 * 1024 * 1024;

    if (form.jpegFile.size > maxFileSize) {
      alert("File size is large. JPEG file must be 5 MB or less.");
      return;
    }

    if (form.embFile.size > maxFileSize) {
      alert("File size is large. EMB/ZIP file must be 5 MB or less.");
      return;
    }

    const formData = new FormData();

    formData.append("category", form.category);
    formData.append("designCode", form.designCode);
    formData.append("stitch", form.stitch);
    formData.append("area", form.area);
    formData.append("color", form.color);
    formData.append("details", form.details);
    formData.append("concepts", JSON.stringify(selectedConcepts));
    formData.append("jpegFile", form.jpegFile);
    formData.append("embFile", form.embFile);

    try {
      const res = await fetch(API.ADD_DESIGN, {
        method: "POST",
        body: formData,
      });

      const text = await res.text();
      const data = JSON.parse(text);

      alert(data.message);

      if (data.status) {
        setForm((prev) => ({
          ...prev,
          jpegFile: null,
          embFile: null,
        }));

        setFileResetKey(Date.now());

        fetchDesigns();
      }
    } catch (error) {
      console.error("Submit error:", error);
      alert("Network error: " + error.message);
    }
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "jpegFile" || name === "embFile") {
      const file = files[0];

      if (file && file.size > MAX_FILE_SIZE) {
        alert(
          `${name === "jpegFile" ? "JPEG" : "EMB"} file size must not be more than 5 MB.`,
        );

        e.target.value = "";
        return;
      }

      setForm({
        ...form,
        [name]: file,
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this design?")) return;

    const formData = new FormData();
    formData.append("id", id);

    try {
      const res = await fetch(API.DELETE_DESIGN, {
        method: "POST",
        body: formData,
      });

      const text = await res.text();

      const data = JSON.parse(text);
      alert(data.message);

      if (data.status) {
        fetchDesigns();
      }
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const handleUpdate = async () => {
    // ==========================================
    // MAX FILE SIZE = 5 MB
    // ==========================================

    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    // ==========================================
    // VALIDATE NEW JPEG
    // ==========================================

    if (editData.jpeg_file instanceof File) {
      if (editData.jpeg_file.size > maxFileSize) {
        alert("File size is large. JPEG file must be 5 MB or less.");
        return;
      }

      const jpegExt = editData.jpeg_file.name.split(".").pop().toLowerCase();

      if (!["jpg", "jpeg", "png"].includes(jpegExt)) {
        alert("Only JPG, JPEG and PNG files are allowed.");
        return;
      }
    }

    // ==========================================
    // VALIDATE NEW EMB / ZIP / RAR
    // ==========================================

    if (editData.emb_file instanceof File) {
      if (editData.emb_file.size > maxFileSize) {
        alert("File size is large. EMB/ZIP/RAR file must be 5 MB or less.");
        return;
      }

      const embExt = editData.emb_file.name.split(".").pop().toLowerCase();

      if (!["emb", "zip", "rar"].includes(embExt)) {
        alert("Only EMB, ZIP and RAR files are allowed.");
        return;
      }
    }

    // ==========================================
    // CREATE FORM DATA
    // ==========================================

    const formData = new FormData();

    formData.append("id", editData.id);
    formData.append("category", editData.category);
    formData.append("design_code", editData.design_code);
    formData.append("stitch", editData.stitch);
    formData.append("area", editData.area);
    formData.append("color", editData.color);
    formData.append("details", editData.details || "");

    // Concepts
    formData.append("concepts", JSON.stringify(editData.concepts_array || []));

    // New JPEG
    if (editData.jpeg_file instanceof File) {
      formData.append("jpeg_file", editData.jpeg_file);
    }

    // New EMB / ZIP / RAR
    if (editData.emb_file instanceof File) {
      formData.append("emb_file", editData.emb_file);
    }

    try {
      const res = await fetch(API.UPDATE_DESIGN, {
        method: "POST",
        body: formData,
      });

      // ==========================================
      // READ SERVER RESPONSE
      // ==========================================

      const text = await res.text();

      console.log("Update response:", text);

      let data;

      try {
        data = JSON.parse(text);
      } catch (jsonError) {
        console.error("Invalid JSON response:", text);

        alert("Server returned an invalid response.");
        return;
      }

      // ==========================================
      // SHOW BACKEND MESSAGE
      // ==========================================

      alert(data.message);

      // ==========================================
      // SUCCESS
      // ==========================================

      if (data.status) {
        setEditData(null);
        fetchDesigns();
      }
    } catch (error) {
      console.error("Update error:", error);
      alert("Network error: " + error.message);
    }
  };
  const handleDownload = async (file, category, designCode) => {
    const url = `${API.DOWNLOAD}?file=FreeDesigns/${file}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        alert("File not found");
        return;
      }

      // Get file as binary
      const blob = await response.blob();

      // Check original extension
      const extension = file.split(".").pop().toLowerCase();

      // Set download name
      let downloadName = designCode;

      if (extension === "txt") {
        // Convert back to .emb name while downloading
        downloadName += ".emb";
      } else {
        // Keep original extension (zip etc.)
        downloadName += "." + extension;
      }

      // Create temporary download URL
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = downloadName;

      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download file");
    }
  };
  const handleConceptChange = (conceptId) => {
    let updatedConcepts = [...selectedConcepts];

    if (updatedConcepts.includes(conceptId)) {
      updatedConcepts = updatedConcepts.filter((id) => id !== conceptId);
    } else {
      updatedConcepts.push(conceptId);
    }

    setSelectedConcepts(updatedConcepts);
    setForm({ ...form, concepts: updatedConcepts });
  };

  const handleEditConcept = async (concept) => {
    const newName = window.prompt("Edit Concept Name:", concept.concept_name);
    if (!newName) return;

    const newCategory = window.prompt("Edit Category:", concept.category);
    if (!newCategory) return;

    const formData = new FormData();
    formData.append("id", concept.id);
    formData.append("concept_name", newName);
    formData.append("category", newCategory);

    try {
      const res = await fetch(API.UPDATE_CONCEPT, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      if (data.status) fetchConcepts();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditConceptChange = (conceptId) => {
    let updated = [...(editData.concepts_array || [])];

    if (updated.includes(conceptId)) {
      updated = updated.filter((id) => id !== conceptId);
    } else {
      updated.push(conceptId);
    }

    setEditData({
      ...editData,
      concepts_array: updated,
    });
  };
  return (
    <div className="ad-container">
      <div className="ad-header">
        <h2 className="ad-title">Design Upload</h2>
        <p className="ad-subtitle">
          Create and manage your embroidery design patterns
        </p>
      </div>

      {/* FORM SECTION */}
      <div className="ad-form-card">
        <form onSubmit={handleSubmit} className="ad-form">
          <div
            className="border-box"
            style={{
              border: "1px solid #495057 ",
              padding: "35px",
              boxShadow: "inset 0 0 0 1px #495057",
              borderRadius: "5px",
            }}
          >
            <h2 className="ad-card-title">
              <i className="bi bi-plus-circle me-2"></i>Add New Design
            </h2>
            <div className="row g-3">
              <div className="col-12 row align-items-center mb-3 mt-4">
                <label className="ad-label col-md-2">Category</label>
                <div className="col-md-10">
                  <select
                    name="category"
                    className="ad-input1"
                    value={form.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                      <option key={cat} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-12 row align-items-center mb-3">
                <label className="ad-label col-md-2">Design Code</label>
                <div className="col-md-10">
                  <input
                    type="text"
                    name="designCode"
                    className="ad-input1"
                    placeholder="e.g. DZN-001"
                    value={form.designCode}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="col-12 row align-items-center mb-3">
                <label className="ad-label col-md-2">Stitch Count</label>
                <div className="col-md-10">
                  <input
                    type="text"
                    name="stitch"
                    className="ad-input1"
                    placeholder="0"
                    value={form.stitch}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="col-12 row align-items-center mb-3">
                <label className="ad-label col-md-2">Color Count</label>
                <div className="col-md-10">
                  <input
                    type="text"
                    name="color"
                    className="ad-input1"
                    placeholder="e.g. 5"
                    value={form.color}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="col-12 row align-items-center mb-3">
                <label className="ad-label col-md-2">Area (Size)</label>
                <div className="col-md-10">
                  <input
                    type="text"
                    name="area"
                    className="ad-input1"
                    value={form.area}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="col-12 row align-items-center mb-3">
                <label className="ad-label col-md-2">JPEG Preview</label>
                <div className="col-md-10">
                  <input
                    key={fileResetKey}
                    type="file"
                    name="jpegFile"
                    accept="image/jpeg,image/jpg"
                    className="ad-input1"
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="col-12 row align-items-center mb-3">
                <label className="ad-label col-md-2">EMB Data File</label>
                <div className="col-md-10">
                  <input
                    key={fileResetKey}
                    type="file"
                    name="embFile"
                    accept=".emb,.zip,.rar"
                    className="ad-input1"
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="col-12 row align-items-center mb-3">
                <label className="ad-label col-md-2">Details</label>

                <div className="col-md-10">
                  <input
                    type="text"
                    name="details"
                    className="ad-input1"
                    placeholder="Enter design details..."
                    value={form.details}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="ad-label mb-0">Concepts</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => setShowConceptModal(true)}
                  >
                    <i className="bi bi-gear-fill me-1"></i> Manage Concepts
                  </button>
                </div>

                <div className="concept-grid-container">
                  {categories.map((category) => {
                    const filtered = concepts.filter(
                      (c) => c.category === category,
                    );

                    if (filtered.length === 0) return null;

                    return (
                      <div key={category} className="colum">
                        {/* Category Title */}
                        <h6 className="fw-bold mb-2">{category}</h6>

                        {/* Horizontal Row */}
                        <div className="concept-row">
                          {filtered.map((concept) => (
                            <label
                              key={concept.id}
                              className="concept-custom-checkbox"
                            >
                              <input
                                type="checkbox"
                                checked={selectedConcepts.includes(concept.id)}
                                onChange={() => handleConceptChange(concept.id)}
                              />
                              <span className="concept-checkmark"></span>
                              <span className="concept-label-text">
                                {concept.concept_name}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="col-12">
                <button type="submit" className="ad-btn-submit">
                  <i className="bi bi-cloud-arrow-up me-2"></i>Save Design
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <hr className="ad-divider" />

      {/* FILTER SECTION */}
      <div className="ad-filter-bar">
        <h4 className="ad-card-title mb-0">Existing Designs</h4>
        <div className="ad-filter-controls">
          <select
            className="ad-input w-auto"
            value={selectedFilterCategory}
            onChange={(e) => setSelectedFilterCategory(e.target.value)}
          >
            <option value="all">All Categories</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
          <div className="ad-search-wrapper">
            <i className="bi bi-search"></i>
            <input
              type="text"
              className="ad-input ad-search-input"
              placeholder="Search code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* TABLE SECTION */}
      <div className="ad-table-responsive">
        <table className="ad-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Image</th>
              <th>Category</th>
              <th>Design Code</th>
              <th>Stitch</th>
              <th>Color</th>
              <th>Area</th>
              <th>Details</th>
              <th>Concept</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.length > 0 ? (
              currentRecords.map((design, index) => (
                <tr key={design.id}>
                  <td data-label=" No ">{indexOfFirstRecord + index + 1}</td>
                  <td>
                    {design.created_at
                      ? new Date(design.created_at).toLocaleDateString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )
                      : "-"}
                  </td>
                  <td data-label="image">
                    <img
                      src={`${UPLOADS.DESIGN_IMAGE}FreeDesigns/${design.jpeg_file}`}
                      alt={design.design_code}
                      className="ad-table-img"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setPreviewImage(
                          `${UPLOADS.DESIGN_IMAGE}FreeDesigns/${design.jpeg_file}`,
                        )
                      }
                    />
                  </td>
                  <td data-label="category">
                    <span className="cat-badge">{design.category}</span>
                  </td>
                  <td className="fw-bold">{design.design_code}</td>

                  <td data-label="stitch">{design.stitch}</td>
                  <td data-label="color">{design.color}</td>
                  <td data-label="area">{design.area}</td>
                  <td data-label="details">{design.details}</td>
                  <td data-label="concepts">
                    {design.concepts_array
                      ?.map((id) => {
                        const concept = concepts.find((c) => c.id === id);
                        return concept ? concept.concept_name : null;
                      })
                      .filter(Boolean)
                      .join(", ")}
                  </td>

                  <td data-label="actions">
                    <div className="ad-action-btns">
                      <button
                        className="ad-icon-btn ad-edit"
                        title="Edit"
                        onClick={() => setEditData(design)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                      <button
                        className="ad-icon-btn ad-delete"
                        title="Delete"
                        onClick={() => handleDelete(design.id)}
                      >
                        <i className="bi bi-trash3"></i>
                      </button>
                      <button
                        className="ad-icon-btn ad-download"
                        title="Download EMB"
                        onClick={() =>
                          handleDownload(
                            design.emb_file,
                            design.category,
                            design.design_code,
                          )
                        }
                      >
                        <i className="bi bi-download"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No designs found matching your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION CONTROLS */}
      {totalPages > 1 && (
        <div className="ad-pagination-container">
          <button
            className="ad-page-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          <span className="ad-page-info">
            Page <strong>{currentPage}</strong> of {totalPages} (
            {filteredDesigns.length} total results)
          </span>

          <button
            className="ad-page-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      )}

      {/* EDIT MODAL */}
      {editData && (
        <div className="ad-modal-overlay">
          <div className="ad-modal-content">
            <div className="ad-modal-header">
              <h4>Update Design Details</h4>
              <button
                className="btn-close"
                onClick={() => setEditData(null)}
              ></button>
            </div>
            <div className="ad-modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="ad-label">Category</label>
                  <select
                    className="ad-input"
                    value={editData.category}
                    onChange={(e) =>
                      setEditData({ ...editData, category: e.target.value })
                    }
                  >
                    {categories.map((cat) => (
                      <option key={cat}>{cat}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="ad-label">Design Code</label>
                  <input
                    className="ad-input"
                    value={editData.design_code}
                    onChange={(e) =>
                      setEditData({ ...editData, design_code: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Stitch</label>
                  <input
                    className="ad-input"
                    value={editData.stitch}
                    onChange={(e) =>
                      setEditData({ ...editData, stitch: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Area</label>
                  <input
                    className="ad-input"
                    value={editData.area}
                    onChange={(e) =>
                      setEditData({ ...editData, area: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Color</label>
                  <input
                    className="ad-input"
                    value={editData.color}
                    onChange={(e) =>
                      setEditData({ ...editData, color: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-12">
                  <label className="ad-label">Details</label>
                  <textarea
                    className="ad-input"
                    rows="3"
                    value={editData.details || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        details: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-12">
                  <label className="ad-label">Concepts</label>

                  <div className="concept-grid-container">
                    {categories.map((category) => {
                      const filtered = concepts.filter(
                        (c) => c.category === category,
                      );

                      if (filtered.length === 0) return null;

                      return (
                        <div key={category} className="colum">
                          {/* Category Title */}
                          <h6 className="fw-bold mb-2">{category}</h6>

                          {/* Horizontal Row */}
                          <div className="concept-row">
                            {filtered.map((concept) => (
                              <label
                                key={concept.id}
                                className="concept-custom-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  checked={editData.concepts_array?.includes(
                                    concept.id,
                                  )}
                                  onChange={() =>
                                    handleEditConceptChange(concept.id)
                                  }
                                />
                                <span className="concept-checkmark"></span>
                                <span className="concept-label-text">
                                  {concept.concept_name}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-12">
                  <label className="ad-label">Update JPEG</label>
                  <input
                    type="file"
                    className="ad-input"
                    accept="image/jpeg,image/jpg"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (file && file.size > 5 * 1024 * 1024) {
                        alert("JPEG file size must not be more than 5 MB.");
                        e.target.value = "";
                        return;
                      }

                      setEditData({
                        ...editData,
                        jpeg_file: file,
                      });
                    }}
                  />
                </div>

                <div className="col-md-12">
                  <label className="ad-label">Update EMB</label>
                  <input
                    type="file"
                    className="ad-input"
                    accept=".emb,.zip,.rar"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (file && file.size > 5 * 1024 * 1024) {
                        alert("EMB file size must not be more than 5 MB.");
                        e.target.value = "";
                        return;
                      }

                      setEditData({
                        ...editData,
                        emb_file: file,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="ad-modal-footer">
              <button
                className="ad-btn-cancel"
                onClick={() => setEditData(null)}
              >
                Close
              </button>
              <button className="ad-btn-submit" onClick={handleUpdate}>
                Update Changes
              </button>
            </div>
          </div>
        </div>
      )}
      {showConceptModal && (
        <div className="ad-modal-overlay">
          <div className="ad-modal-content concept-mgmt-modal">
            <div className="ad-modal-header">
              <h4>
                <i className="bi bi-gear-wide-connected me-2"></i>Manage
                Concepts
              </h4>
              <button
                className="btn-close"
                onClick={() => setShowConceptModal(false)}
              ></button>
            </div>

            <div className="ad-modal-body">
              {/* ADD NEW CONCEPT SECTION */}
              <div className="concept-add-box mb-4">
                <label className="ad-label">Add New Concept</label>
                <div className="row g-2">
                  <div className="col-md-5">
                    <select
                      className="ad-input"
                      value={form.category || ""}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          category: e.target.value,
                        }))
                      }
                    >
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-5">
                    <input
                      type="text"
                      className="ad-input"
                      placeholder="Enter concept name..."
                      value={newConcept}
                      onChange={(e) => setNewConcept(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      className="ad-btn-submit"
                      onClick={async () => {
                        if (!newConcept.trim() || !form.category) {
                          alert(
                            "Please select category and enter concept name",
                          );
                          return;
                        }

                        const formData = new FormData();
                        formData.append("concept", newConcept);
                        formData.append("category", form.category);

                        try {
                          const res = await fetch(API.ADD_CONCEPT, {
                            method: "POST",
                            body: formData,
                          });
                          const data = await res.json();

                          if (data.status) {
                            fetchConcepts();
                            setNewConcept("");
                            setForm((prev) => ({ ...prev, category: "" }));
                            alert(data.message);
                          } else {
                            alert(data.message);
                          }
                        } catch (error) {
                          alert("Network error: " + error.message);
                        }
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>

              {/* ✅ GROUPED CONCEPTS BY CATEGORY */}
              <label className="ad-label mb-3">
                Existing Concepts ({concepts.length})
              </label>

              <div className="category-grouped-concepts">
                {categories.map((category) => {
                  // Filter concepts for this category
                  const categoryConcepts = concepts.filter(
                    (concept) => concept.category === category,
                  );

                  // Only show category if it has concepts
                  if (categoryConcepts.length === 0) return null;

                  return (
                    <div key={category} className="category-section mb-4">
                      {/* Category Header */}
                      <div className="category-header">
                        <h6 className="category-title">
                          <i className="bi bi-folder-fill me-2"></i>
                          {category} ({categoryConcepts.length})
                        </h6>
                      </div>

                      {/* Concepts List for this category */}
                      <div className="concept-master-list">
                        {categoryConcepts.map((concept) => (
                          <div key={concept.id} className="concept-mgmt-item">
                            <div className="concept-info">
                              <span className="concept-name">
                                {concept.concept_name}
                              </span>
                              <span className="concept-category-badge ms-2">
                                {concept.category}
                              </span>
                            </div>
                            <div className="concept-item-actions">
                              <button
                                className="c-btn c-edit"
                                title="Edit Concept"
                                onClick={() => handleEditConcept(concept)}
                              >
                                <i className="bi bi-pencil"></i>
                              </button>
                              <button
                                className="c-btn c-delete"
                                title="Delete Concept"
                                onClick={() => handleDeleteConcept(concept.id)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}

                {/* Show "No concepts" if none exist */}
                {concepts.length === 0 && (
                  <div className="text-center py-5">
                    <i className="bi bi-inbox display-4 text-muted mb-3"></i>
                    <p className="text-muted">
                      No concepts found. Add your first concept above!
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="ad-modal-footer">
              <button
                className="ad-btn-cancel w-100"
                onClick={() => setShowConceptModal(false)}
              >
                Close Manager
              </button>
            </div>
          </div>
        </div>
      )}
      {previewImage && (
        <div className="preview-modal" onClick={() => setPreviewImage("")}>
          <div
            className="preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-close"
              onClick={() => setPreviewImage("")}
            >
              &times;
            </button>

            <img src={previewImage} alt="Preview" />
          </div>
        </div>
      )}
    </div>
  );
}
